import { AnyAction } from "redux"

export const REMOVE = "REMOVE"

export interface Remove<T = any, D = any> extends AnyAction {
  resolved: typeof REMOVE
  type: T
  payload: D
}
